import React from 'react';
import { getColumns } from './columns';
import { VehiclesListComponent } from '../VehiclesList';
import { VehicleTypes } from 'ducks/vehicles/common/types';
import { useTranslation } from 'react-i18next';

export const BikesAndVAEList = () => {
    const { t } = useTranslation();
    const types = React.useMemo(
        () => [VehicleTypes.BIKE, VehicleTypes.VAE],
        [],
    );
    return (
        <VehiclesListComponent
            getColumns={getColumns}
            vehicleTypes={types}
            title={t('bikes.title')}
        />
    );
};
